module.exports = __webpack_public_path__ + "img/1-4.cc2a8585.svg";